import React from 'react';
import { Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';


const BranchSalesButtons = ({ moduleType, formData, formConfig, viewOnly, setFormData, EditRecordId,handleSubmit }) => {
  const navigate = useNavigate();

  return (
    <div className="auditBtns">
      <Button
        type="button"
        className="cancelBtn"
        onClick={() => {
          navigate("/audit/branch-sales-list");
        }}
      >
        Back
      </Button>

      {!viewOnly && (
        <>

          <Button type="button" className="submitBtn"
            
          >Post</Button>
         {!formData[0]?.id && (
          <Button
            type="button"
            className="saveBtn"
           
          >
            Save
          </Button>
         )}
          </>
      )}
    </div>
  );
};

export default BranchSalesButtons;
